import { styled } from '@mui/material/styles';
import { DialogSelectTrigger } from 'components/ui';

export const FirmDocumentDialogSearchableSelectRoot = styled('div')(({ theme }) => ({
  color: theme.palette.neutral[600],
  display: 'grid',
  fontSize: 'var(--dialog-description-font-size)',
  fontWeight: theme.typography.fontWeightMedium,
  gap: theme.spacing(1),
  lineHeight: 'var(--dialog-description-line-height)',
  minWidth: 0,
}));

export const FirmDocumentDialogSearchableSelectTrigger = styled(DialogSelectTrigger)(({ theme }) => ({
  '&&': {
    borderRadius: 'var(--dialog-select-trigger-radius)',
    fontSize: 'var(--dialog-description-font-size)',
    lineHeight: 'var(--dialog-description-line-height)',
    minWidth: 0,
    width: '100%',
  },
  '& [class*="DialogSelectTriggerValue"]': {
    minWidth: 0,
  },
  '&:hover': {
    backgroundColor: theme.palette.neutral[50],
  },
}));
